import React, {useCallback, useImperativeHandle, useState} from 'react';
import { useDispatch } from 'react-redux';
import { updateInventoryRequest } from '../../../store/slices/boardSlice';
import s from '../Settings/SettingsBlock.module.css';
import sg from '../../../../styles/index.module.css';

// eslint-disable-next-line no-underscore-dangle
function _Price({ value, type, labelText, inventoryGuid, hasFullAccess, warehouseId, updateCost }, forwardedRef) {
    const [savedValue, setSavedValue] = useState(String(value).replace('.', ','));
    const [editedValue, setEditedValue] = useState(savedValue);
    const [isFocused, setIsFocused] = useState(false);
    const dispatch = useDispatch();

    const update = useCallback(
        (newValue) => {
            setSavedValue(newValue);
            setEditedValue(newValue);
        },
        [setSavedValue]
    );
    
    useImperativeHandle(
        forwardedRef,
        () => ({
            update,
        }),
        [update]
    );

    const prepareNumber = (n) => {
        if (n === '') {
            return '0';
        }
        n = n.replace(/ /g, '').replace(/,/g, '.').split('.');
        if (n.length === 0) {
            return '0';
        }
        let leftPart = n[0].substr(0, 10);
        if (n.length === 1) {
            return parseInt(leftPart, 10).toString();
        }
        const rightPart = n[1].substr(0, 6);
        if (leftPart === '') {
            leftPart = 0;
        }
        if (rightPart === '') {
            return parseInt(leftPart, 10).toString();
        }

        return `${parseInt(leftPart, 10)},${rightPart}`;
    };

    const setValue = (e) => {
        e.preventDefault();
        const val = prepareNumber(
            String(editedValue).trim().replace('.', ',').replace(/\s/g, '')
        );

        setEditedValue(val.toString());
        if (val === savedValue) {
            return;
        }
        setSavedValue(val.toString());
        if (editedValue.trim() === '') {
            setEditedValue('0');
        }
        dispatch(
            updateInventoryRequest({
                body: JSON.stringify({ [type]: val || 0 }),
                inventoryGuid,
                warehouseId,
            }, (data) => {
                updateCost(data.response.cost);
            })
        );
    };

    const displayValue = isFocused ? editedValue : numberFormatter.formatNumber(editedValue);

    return (
        <div className={s.price}>
            <label>
                <span className={s.title}>{labelText}</span>
                {hasFullAccess && (
                    <input
                        data-id="inventory-price"
                        type="text"
                        className={sg.input}
                        value={displayValue}
                        onFocus={(e) => {
                            setIsFocused(true);
                            e.target.select();
                        }}
                        onBlur={(e) => {
                            setIsFocused(false);
                            setValue(e);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.currentTarget.blur();
                            }
                        }}
                        onChange={(e) => {
                            const { value: newValue } = e.target;
                            const regexp = /^[0-9\-,.\s]*$/;
                            if (regexp.test(newValue)) {
                                setEditedValue(String(newValue));
                            }
                        }}
                    />
                )}
                {!hasFullAccess && <div className={s.valueText}>{displayValue}</div>}
            </label>
        </div>
    );
}

export const Price = React.forwardRef(_Price);
